import { motion } from "framer-motion";

export const Hero = ({ content }) => {
  const c = content || {};
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="krye"
      data-testid="hero-section"
      className="relative h-[100svh] min-h-[640px] w-full overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={c.image_url}
          alt="San Martino 26"
          className="w-full h-full object-cover animate-kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      <div className="hidden md:block absolute left-12 top-1/3 bottom-1/3 w-px bg-white/30" />
      <div className="hidden md:block absolute right-12 top-1/3 bottom-1/3 w-px bg-white/30" />

      <div className="relative z-10 sm-container pt-28 md:pt-36">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          data-testid="hero-eyebrow"
          className="text-[0.7rem] tracking-[0.36em] uppercase text-white/80 font-medium"
        >
          {c.eyebrow}
        </motion.p>
      </div>

      <div className="relative z-10 sm-container h-full flex flex-col justify-center -mt-20 md:-mt-24">
        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          data-testid="hero-title"
          className="font-serif text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] max-w-4xl flex flex-col items-start gap-6"
        >
          {c.title_image_url && (
            <img 
              src={c.title_image_url} 
              alt={c.title || "Hero Title Image"} 
              className="w-auto object-contain h-[var(--hero-title-mob)] md:h-[var(--hero-title-desk)]" 
              style={{
                "--hero-title-mob": c.title_image_height_mobile || "80px",
                "--hero-title-desk": c.title_image_height_desktop || "120px"
              }}
            />
          )}
          
          {(c.title || c.subtitle) && (
            <div>
              {c.title}
              {c.subtitle && (
                <span className="block text-2xl sm:text-3xl md:text-4xl mt-4 italic font-light text-white/80">
                  {c.subtitle}
                </span>
              )}
            </div>
          )}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.7 }}
          data-testid="hero-copy"
          className="mt-10 max-w-xl text-base md:text-lg leading-relaxed text-white/85 font-light whitespace-pre-line"
        >
          {c.copy}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.95 }}
          className="mt-12 flex flex-wrap gap-5 items-center"
        >
          <button
            data-testid="hero-cta-reserve"
            onClick={() => scrollTo("rezervo")}
            className="group relative inline-flex items-center gap-3 bg-sm-bg text-sm-text px-8 py-4 text-[0.78rem] tracking-[0.28em] uppercase font-medium border border-sm-bg hover:bg-transparent hover:text-sm-bg transition-colors duration-500"
          >
            {c.cta_primary}
            <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">→</span>
          </button>
          <button
            data-testid="hero-cta-menu"
            onClick={() => scrollTo("menu")}
            className="text-white/85 text-[0.78rem] tracking-[0.28em] uppercase font-medium sm-link-underline"
          >
            {c.cta_secondary}
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3 text-white/70"
      >
        <span className="text-[0.65rem] tracking-[0.4em] uppercase">Zbulo</span>
        <span className="block w-px h-12 bg-white/40 animate-pulse" />
      </motion.div>
    </section>
  );
};

export default Hero;
